import React, { Fragment, useState } from "react";

const Error = ({ msg, setParentState }) => {
  const [isVisible, setSetIsVisible] = useState(true);
  return (
    <Fragment>
      {isVisible ? (
        <div className="message-box error p-4 pb-0 pt-o">
          <p>{msg}</p>
          <button
            className="close-btn"
            onClick={() => {
              setSetIsVisible(false);
              if(setParentState){
                setParentState("");
              }
            }}
          >
            <span className="close_icon"></span>
          </button>
        </div>
      ) : null}
    </Fragment>
  );
};
export default Error;
